import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Send = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M20 9.998c0-.257-.07-.508-.201-.725a1.3 1.3 0 0 0-.54-.5L1.85.13A1.24 1.24 0 0 0 .437.34a1.4 1.4 0 0 0-.392.666c-.066.257-.058.528.022.78L1 8.421l8.458 1.243c.36.064.36.607 0 .67L1 11.58l-.935 6.633a1.41 1.41 0 0 0 .315 1.39l.057.056c.19.177.426.29.677.328s.508-.003.738-.117l17.409-8.643c.45-.224.739-.703.739-1.228" }) }));
});
Send.displayName = 'Send';
Send.__iconComponentType = 'standard';
export default Send;
//# sourceMappingURL=Send.js.map